/* eslint-disable react/prop-types */
import React, { useRef } from 'react'
import * as d3 from 'd3'
import { getSVGRectPositioning } from 'bam-node-baseball-savant/constants/zone.ts'

import { useChartOptions, useScales } from '../../../Context/ChartContext.tsx'

function useId() {
    const idRef = useRef(`id-${Math.random().toString(36).substring(2, 9)}`)
    return idRef.current
}

const defaultStrokeWidth = 4

export default function StrikeZoneFuzzyBackground({
    bgColor,
}: {
    bgColor: string
}) {
    const { settings } = useChartOptions()
    const { data } = settings

    const { xScale, yScale } = useScales()

    const [topMin, topMax] = d3.extent(data, (d) => d.szTop)
    const [botMin, botMax] = d3.extent(data, (d) => d.szBot)

    if (topMin === undefined || topMax === undefined) {
        console.warn('No data or no strike zone data')
        return null
    }
    if (botMin === undefined || botMax === undefined) {
        console.warn('No data or no strike zone data')
        return null
    }

    const dims = getSVGRectPositioning(
        topMax,
        botMin,
        17 / 12,
        xScale,
        yScale,
        defaultStrokeWidth
    )

    const patternId = useId()

    return (
        <g id="strikeZone">
            <defs>
                <defs>
                    <pattern
                        id={patternId}
                        patternUnits="userSpaceOnUse"
                        width="10"
                        height="10"
                        patternTransform="rotate(45)"
                    >
                        <rect height="10" width="10" fill={bgColor} />
                        <line
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="10"
                            stroke="#ffffff"
                            strokeWidth="6"
                        />
                        <line
                            x1="0"
                            y1="0"
                            x2="10"
                            y2="0"
                            stroke="#ffffff"
                            strokeWidth="6"
                        />
                    </pattern>
                </defs>
            </defs>

            <rect
                className="strike-zone"
                style={{ pointerEvents: 'none' }}
                x={dims.x}
                width={dims.width}
                y={dims.y}
                height={dims.height}
                strokeWidth={defaultStrokeWidth}
                fill={`url(#${patternId})`}
                strokeOpacity={0.5}
                stroke="#ccc"
            />
        </g>
    )
}
